import React from 'react'
import { DigitalVaultCompaniesAction, DigitalVaultDocumentAction, SyncfusionFileManagerAction } from '../../actions'
import './digital-vault-home.css'

const DigitalVaultHomeView = (props) => {
    if (props.documentId) {
        return (
            <DigitalVaultDocumentAction
                {...props}
                documentId={props.documentId}
                isFromDigitalVault={true}
                stateToMaintain={{
                    selectedCompany: props.selectedCompany,
                    selectedCategory: props.selectedCategory,
                    subcategoryPath: props.subcategoryPath,
                    selectedDocument: props.selectedDocument
                }}
            />
        )
    } else if (props.selectedCompany) {
        return <SyncfusionFileManagerAction {...props} />
    } else {
        return <DigitalVaultCompaniesAction {...props} />
    }
}

export default DigitalVaultHomeView